<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";

export default {
  inject: ['setLoading'],
  data() {
    return {
      title: "Finance & Accounts",
      text: "Finance & Accounts",
      data: [],
      pagination: {
       current_page: 1,
       per_page: 25,
       last_page: 1,
       total: 0,
       links: []
      },
      filter: {
       search: '',
       from_date: '',
       to_date: ''
      },
      loading: false,
    };
  },

  computed: {
   text1(){
    return `Zoho Payment History (${this.pagination.total})`;
   }, 
   serialNo(){
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   } 
  },

  mounted(){
   this.zohoPaymentHistory();

   const start = moment().subtract(29, "days");
   const end = moment();

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        locale: {
         format: "DD/MM/YYYY",
         separator: " - "
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.setDateRange(start, end);
      },
      this.booking_range
    );
    // Initialize filter date range as soon as picker mounts
    this.setDateRange(start, end);

  }, 

  methods: {

    booking_range(start, end) {
     return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
    },

    setDateRange(start, end) {
     this.filter.from_date = start.format("YYYY-MM-DD");
     this.filter.to_date = end.format("YYYY-MM-DD");
    },

    async zohoPaymentHistory(page = 1) {
     this.setLoading(true);
     try{
      const params = {
       page,
       per_page: this.pagination.per_page,
       from_date: this.filter.from_date,
       to_date: this.filter.to_date,
       search: this.filter.search.trim() || ''
      };
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/zoho-payments/history?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    changePage(url){
     if (!url) return;
     const page = new URL(url).searchParams.get("page");
     this.zohoPaymentHistory(page);
    },

   clearFilter(){
    this.filter.search = '';
    this.zohoPaymentHistory();
   },
    
  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        
        <div class="mb-2">
         <router-link :to="{name: 'zoho-payments'}" class="btn btn-warning d-flex align-items-center">
          <i class="ti ti-history me-2"></i>Back to Zoho Payments
         </router-link>
        </div>
       
      </div>
    </div>
    <!-- /Breadcrumb -->

    <div class="card">
    <div class="card-header d-flex align-items-center justify-content-center flex-wrap row-gap-3">
    <!-- <h5>Payments List</h5> -->
    
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-1" v-if="filter.search !== '' ">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
     <div class="input-icon-end position-relative">
      <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
      <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
     </div>
    </div>

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="filter.search" placeholder="Search...."/>
    </div>
    </div>

    <div class="">
     <button type="button" class="btn btn-dark" @click="zohoPaymentHistory()"><i class="ti ti-search"></i></button>
    </div>

    </div>
    
   </div>

  <div class="card-body p-0">
    <div class="custom-datatable-filter table-responsive" v-if="data?.length">
      <table class="table datatable thead-light">
        <thead>
          <tr>
            <th>#</th>
            <th>Total Balance</th>
            <th>Uploaded At</th>
            <!-- <th>Actions</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in data" :key="row.id">
            <td>{{ serialNo + index + 1 }}.</td>  
            <td>{{ row.total_balance }}</td>
            <td>{{ $formatDate(row.created_at, 'DD-MM-YYYY') }}</td>

            <!-- <td>
            <div class="dropdown">
            <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="ti ti-dots-vertical"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#admin_modal" @click="$refs.subadminModal.editAdmin(row)"><i class="ti ti-edit me-1"></i>Edit</a>
            </li>
            </ul>
            </div>  
            </td> -->

          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
    <nav v-if="pagination.links.length > 3" class="mt-2 margin-l-2">
     <ul class="pagination pagination-sm">
      <li v-for="(link, index) in pagination.links" :key="index" :class="['page-item', { active: link.active, disabled: !link.url }]">
        <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
      </li>
     </ul>
    </nav>

    </div>

    <div v-else class="p-3 text-center text-muted"> No records found.</div>
    
  </div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

</template>